import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../../resources/css/adminlte.css";
import "../../../resources/css/custom.css";

// 🔧 Estilos inline para selectores y mejoras móviles completas
const selectDebugStyles = `
select {
    pointer-events: auto !important;
    z-index: 1 !important;
    position: relative !important;
    opacity: 1 !important;
    visibility: visible !important;
    cursor: pointer !important;
}

select.form-control {
    pointer-events: auto !important;
    z-index: 1 !important;
    position: relative !important;
    opacity: 1 !important;
    visibility: visible !important;
    cursor: pointer !important;
}

/* 🔧 MEJORAS MÓVILES COMPLETAS PARA HAMBURGER BUTTON */
.navbar-nav .nav-link {
    min-height: 44px !important;
    min-width: 44px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    touch-action: manipulation !important;
    -webkit-tap-highlight-color: rgba(255,255,255,0.2) !important;
    -webkit-touch-callout: none !important;
    -webkit-user-select: none !important;
    -khtml-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    user-select: none !important;
    position: relative !important;
    z-index: 1000 !important;
}

.navbar-nav .nav-link i {
    pointer-events: none !important;
    font-size: 1.1rem !important;
    transition: transform 0.1s ease !important;
}

.navbar-nav .nav-link:active i {
    transform: scale(0.95) !important;
}

/* 🔧 Mejoras específicas para móvil y tablet (pantallas pequeñas y medianas) */
@media (max-width: 1024px) {
    .navbar-nav .nav-link {
        min-height: 50px !important;
        min-width: 50px !important;
        padding: 15px !important;
        margin: 2px !important;
        border-radius: 4px !important;
        background-color: rgba(255,255,255,0.1) !important;
        transition: all 0.2s ease !important;
    }
    
    .navbar-nav .nav-link:hover,
    .navbar-nav .nav-link:focus,
    .navbar-nav .nav-link:active {
        background-color: rgba(255,255,255,0.2) !important;
        transform: scale(1.05) !important;
    }
    
    .navbar-nav .nav-link i {
        font-size: 1.3rem !important;
        color: #ffffff !important;
    }
    
    /* Asegurar que el hamburger button sea completamente táctil */
    .navbar-nav .nav-item:first-child .nav-link {
        background-color: rgba(255,255,255,0.15) !important;
        border: 2px solid rgba(255,255,255,0.3) !important;
    }
    
    .navbar-nav .nav-item:first-child .nav-link:active {
        background-color: rgba(255,255,255,0.3) !important;
        border-color: rgba(255,255,255,0.5) !important;
    }
}

/* 🔧 Mejoras para pantallas muy pequeñas (móviles en portrait) */
@media (max-width: 480px) {
    .navbar-nav .nav-link {
        min-height: 52px !important;
        min-width: 52px !important;
        padding: 16px !important;
    }
    
    .navbar-nav .nav-link i {
        font-size: 1.4rem !important;
    }
    
    /* Hacer el área de toque aún más grande para el hamburger */
    .navbar-nav .nav-item:first-child .nav-link {
        min-height: 56px !important;
        min-width: 56px !important;
    }
}

/* 🔧 Asegurar que el sidebar toggle funcione correctamente */
body.sidebar-collapse .main-sidebar {
    margin-left: -250px !important;
}

body:not(.sidebar-collapse) .main-sidebar {
    margin-left: 0 !important;
}

/* 🔧 Mejoras para la transición del sidebar en móvil */
@media (max-width: 768px) {
    .main-sidebar {
        transition: margin-left 0.3s ease !important;
        z-index: 1050 !important;
    }
    
    body.sidebar-collapse .content-wrapper {
        margin-left: 0 !important;
    }
    
    body:not(.sidebar-collapse) .content-wrapper {
        margin-left: 0 !important;
    }
    
    /* 🔧 OVERLAY OSCURO PARA MÓVIL */
    body.sidebar-open-mobile::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1040;
        opacity: 1;
        transition: opacity 0.3s ease;
        pointer-events: auto;
    }
    
    /* Asegurar que el sidebar esté por encima del overlay */
    body.sidebar-open-mobile .main-sidebar {
        z-index: 1060 !important;
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        height: 100vh !important;
        margin-left: 0 !important;
        transform: translateX(0) !important;
    }
    
    /* Cuando está colapsado en móvil, ocultar completamente */
    body.sidebar-collapse .main-sidebar {
        transform: translateX(-100%) !important;
        margin-left: 0 !important;
    }
    
    /* Prevenir scroll del body cuando el sidebar está abierto */
    body.sidebar-open-mobile {
        overflow: hidden !important;
    }
}

/* 🎨 CORRECCIONES ESTÉTICAS GLOBALES */
body .wrapper .content-wrapper,
.wrapper .content-wrapper,
.content-wrapper {
    background-color: #ffffff !important;
}

body .main-sidebar,
body .sidebar,
.main-sidebar,
.sidebar {
    min-height: 100vh !important;
    height: auto !important;
}

/* Asegurar que el sidebar se extienda con el contenido */
html body .main-sidebar,
html body .sidebar {
    min-height: 100vh !important;
    height: auto !important;
}

/* Forzar el fondo blanco en todas las variantes */
html body .wrapper .content-wrapper,
html body .content-wrapper {
    background-color: #ffffff !important;
}
`;

const DEBUG_HEADER = false;
const headerDebug = (...args) => {
    if (DEBUG_HEADER) {
        console.log(...args);
    }
};

function Header(props) {

    const [headerclass, setHeaderclass] = useState('');
    const [showUserDropdown, setShowUserDropdown] = useState(false);
    const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false); // 🔧 Estado para controlar el sidebar en móvil
    const location = useLocation(); // 🔧 Hook para detectar cambios de ruta

    useEffect(() => {
        // 🔧 CORREGIDO: Siempre mostrar el botón hamburger
        // Solo ocultar si explícitamente no hay userdata (usuario no logueado)
        if (!localStorage.getItem('userdata')) {
            setHeaderclass('main-header-collapsed');
        } else {
            setHeaderclass(''); // Siempre mostrar header completo si hay usuario logueado
        }
        
        // 🔧 Inicializar funcionalidad móvil mejorada
        const initMobileFunctionality = () => {
            headerDebug('🔧 Initializing mobile functionality');
            
            // Detectar si es dispositivo móvil o tablet
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            const isSmallScreen = window.innerWidth <= 1024; // 🔧 Aumentado de 768 a 1024 para incluir tablets
            
            if (isMobile || isSmallScreen) {
                headerDebug('🔧 Mobile/Tablet device detected, applying mobile optimizations');
                
                // Asegurar que el body tenga las clases correctas para móvil
                const body = document.querySelector('body');
                if (body) {
                    body.classList.add('mobile-device');
                    
                    // 🔧 Inicializar sidebar cerrado en móvil/tablet
                    body.classList.add('sidebar-collapse');
                    setSidebarOpen(false);
                    
                    // Agregar listener para cambios de orientación
                    const handleOrientationChange = () => {
                        setTimeout(() => {
                            headerDebug('🔧 Orientation changed, recalculating layout');
                            // Forzar recálculo del layout
                            body.style.transform = 'translateZ(0)';
                            setTimeout(() => {
                                body.style.transform = '';
                            }, 10);
                        }, 100);
                    };
                    
                    // 🔧 Listener para cambios de tamaño de pantalla
                    const handleResize = () => {
                        const newIsSmallScreen = window.innerWidth <= 1024; // 🔧 Actualizado breakpoint
                        if (!newIsSmallScreen && sidebarOpen) {
                            // Si cambiamos a pantalla grande, cerrar el sidebar móvil
                            setSidebarOpen(false);
                            body.classList.remove('sidebar-open-mobile');
                        }
                    };
                    
                    window.addEventListener('orientationchange', handleOrientationChange);
                    window.addEventListener('resize', handleResize);
                    
                    // Cleanup function
                    return () => {
                        window.removeEventListener('orientationchange', handleOrientationChange);
                        window.removeEventListener('resize', handleResize);
                    };
                }
            }
        };
        
        const cleanup = initMobileFunctionality();
        
        return cleanup;
    },[]);

    // 🔧 useEffect para resetear hover states al montar el componente
    useEffect(() => {
        // Reset inicial de hover states
        const initialReset = () => {
            setTimeout(() => {
                resetHoverStates();
            }, 500); // Delay para asegurar que el DOM esté listo
        };
        
        initialReset();
        
        // También resetear en focus/blur de la ventana
        const handleWindowFocus = () => {
            resetHoverStates();
        };
        
        window.addEventListener('focus', handleWindowFocus);
        window.addEventListener('blur', handleWindowFocus);
        
        return () => {
            window.removeEventListener('focus', handleWindowFocus);
            window.removeEventListener('blur', handleWindowFocus);
        };
    }, []);

    // 🔧 Función mejorada para manejar el toggle del sidebar con soporte móvil completo
    const handleSidebarToggle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        headerDebug('🔧 Sidebar toggle clicked/touched'); // Debug para móvil
        
        // Buscar el body y agregar/quitar la clase sidebar-collapse
        const body = document.querySelector('body');
        if (body) {
            const isCollapsed = body.classList.contains('sidebar-collapse');
            const isMobile = window.innerWidth <= 1024; // 🔧 Actualizado para incluir tablets
            
            if (isCollapsed) {
                body.classList.remove('sidebar-collapse');
                if (isMobile) {
                    setSidebarOpen(true); // 🔧 Actualizar estado para móvil/tablet
                    body.classList.add('sidebar-open-mobile'); // 🔧 Clase específica para móvil/tablet
                }
                headerDebug('🔧 Sidebar expanded'); // Debug
            } else {
                body.classList.add('sidebar-collapse');
                if (isMobile) {
                    setSidebarOpen(false); // 🔧 Actualizar estado para móvil/tablet
                    body.classList.remove('sidebar-open-mobile'); // 🔧 Remover clase móvil/tablet
                }
                headerDebug('🔧 Sidebar collapsed'); // Debug
            }
            
            // 🔧 Forzar repaint para dispositivos móviles
            body.style.transform = 'translateZ(0)';
            setTimeout(() => {
                body.style.transform = '';
            }, 10);
            
            // 🔧 Disparar evento personalizado para notificar el cambio
            const sidebarEvent = new CustomEvent('sidebarToggle', {
                detail: { collapsed: !isCollapsed }
            });
            window.dispatchEvent(sidebarEvent);
            
        } else {
            headerDebug('❌ Body element not found'); // Debug
        }
    };

    // 🔧 Función para cerrar el sidebar (especialmente útil para móvil)
    const closeSidebar = () => {
        const body = document.querySelector('body');
        if (body) {
            body.classList.add('sidebar-collapse');
            body.classList.remove('sidebar-open-mobile');
            setSidebarOpen(false);
            headerDebug('🔧 Sidebar closed via overlay click');
        }
    };

    // 🔧 Función específica para eventos táctiles en móvil con mejor manejo
    const handleSidebarToggleTouch = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        headerDebug('🔧 Touch event detected on hamburger button'); // Debug
        
        // 🔧 Agregar feedback visual inmediato con validación null-safe
        const target = e.currentTarget;
        if (target && target.style) {
            target.style.transform = 'scale(0.95)';
            setTimeout(() => {
                if (target && target.style) {
                    target.style.transform = '';
                }
            }, 150);
        }
        
        // Ejecutar el toggle con un pequeño delay para el feedback visual
        setTimeout(() => {
            handleSidebarToggle(e);
        }, 50);
    };

    // 🔧 Función para manejar tanto click como touch de manera unificada
    const handleSidebarToggleUnified = (e) => {
        // Prevenir múltiples ejecuciones
        if (e.type === 'touchstart' && e.touches && e.touches.length > 1) {
            return; // Ignorar multi-touch
        }
        
        e.preventDefault();
        e.stopPropagation();
        
        headerDebug(`🔧 Unified event: ${e.type}`); // Debug
        
        // 🔧 Feedback visual con validación null-safe
        const target = e.currentTarget;
        if (target && target.style) {
            target.style.transform = 'scale(0.95)';
            target.style.opacity = '0.8';
            setTimeout(() => {
                if (target && target.style) {
                    target.style.transform = '';
                    target.style.opacity = '';
                }
            }, 150);
        }
        
        handleSidebarToggle(e);
        
        // 🔧 Reset hover state después de la interacción
        setTimeout(() => {
            resetHoverStates();
        }, 300);
    };

    // 🔧 Función para manejar dropdown de usuario
    const handleUserDropdown = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowUserDropdown(!showUserDropdown);
        setShowNotificationDropdown(false); // Cerrar el otro dropdown
        
        // 🔧 Reset hover state después de la interacción
        setTimeout(() => {
            resetHoverStates();
        }, 200);
    };

    // 🔧 Función para manejar dropdown de notificaciones
    const handleNotificationDropdown = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowNotificationDropdown(!showNotificationDropdown);
        setShowUserDropdown(false); // Cerrar el otro dropdown
        
        // 🔧 Reset hover state después de la interacción
        setTimeout(() => {
            resetHoverStates();
        }, 200);
    };

    // 🔧 Función para resetear estados hover persistentes en móvil
    const resetHoverStates = () => {
        const isMobile = window.innerWidth <= 1024; // 🔧 Actualizado para incluir tablets
        if (isMobile) {
            // Buscar todos los botones del navbar
            const navLinks = document.querySelectorAll('.main-header .navbar-nav .nav-link');
            
            navLinks.forEach(link => {
                // Remover clases de hover/focus persistentes
                link.classList.remove('hover', 'focus', 'active');
                
                // Forzar reset de estilos inline
                if (link.style) {
                    link.style.transform = '';
                    link.style.opacity = '';
                    link.style.backgroundColor = '';
                }
                
                // Agregar clase temporal para forzar reset
                link.classList.add('hover-reset');
                
                // Remover la clase después de un momento
                setTimeout(() => {
                    link.classList.remove('hover-reset');
                }, 100);
            });
            
            headerDebug('🔧 Hover states reset for mobile/tablet');
        }
    };

    // 🔧 useEffect para cerrar sidebar al cambiar de ruta (solucionar overlay persistente)
    useEffect(() => {
        // Cerrar sidebar cuando cambie la ruta
        const isMobile = window.innerWidth <= 1024; // 🔧 Actualizado para incluir tablets
        if (isMobile && sidebarOpen) {
            headerDebug('🔧 Route changed, closing sidebar');
            closeSidebar();
        }
        
        // 🔧 Resetear estados hover persistentes al cambiar de ruta
        resetHoverStates();
        
    }, [location.pathname]); // 🔧 Dependencia en location.pathname para detectar cambios de ruta

    // 🔧 Cerrar dropdowns al hacer click fuera y configurar listeners móviles
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('#menu-personal') && !event.target.closest('#menu-notifications')) {
                setShowUserDropdown(false);
                setShowNotificationDropdown(false);
            }
        };

        // 🔧 Listener para cerrar sidebar al hacer click en el overlay (móvil/tablet)
        const handleOverlayClick = (event) => {
            const isMobile = window.innerWidth <= 1024; // 🔧 Actualizado para incluir tablets
            if (isMobile && sidebarOpen) {
                // Si el click es en el overlay (no en el sidebar)
                if (!event.target.closest('.main-sidebar') && !event.target.closest('.navbar-nav')) {
                    closeSidebar();
                }
            }
        };

        // 🔧 Listener para cerrar sidebar al hacer click en links del sidebar (móvil/tablet)
        const handleSidebarLinkClick = (event) => {
            const isMobile = window.innerWidth <= 1024; // 🔧 Actualizado para incluir tablets
            if (isMobile && sidebarOpen) {
                // Si el click es en un link del sidebar
                if (event.target.closest('.main-sidebar .nav-link') || 
                    event.target.closest('.main-sidebar a')) {
                    headerDebug('🔧 Sidebar link clicked, closing sidebar');
                    // Delay pequeño para permitir que la navegación ocurra primero
                    setTimeout(() => {
                        closeSidebar();
                    }, 100);
                }
            }
        };

        // 🔧 Listener adicional específico para el sidebar usando delegación de eventos
        const addSidebarLinkListeners = () => {
            const sidebar = document.querySelector('.main-sidebar');
            if (sidebar) {
                const handleSidebarNavigation = (e) => {
                    const isMobile = window.innerWidth <= 1024; // 🔧 Actualizado para incluir tablets
                    if (isMobile && sidebarOpen) {
                        // Verificar si es un link de navegación
                        const isNavLink = e.target.closest('a[href]') || 
                                         e.target.closest('.nav-link') ||
                                         e.target.tagName === 'A';
                        
                        if (isNavLink) {
                            headerDebug('🔧 Navigation link in sidebar clicked');
                            // Cerrar sidebar después de un pequeño delay
                            setTimeout(() => {
                                closeSidebar();
                                resetHoverStates();
                            }, 150);
                        }
                    }
                };
                
                sidebar.addEventListener('click', handleSidebarNavigation);
                
                return () => {
                    sidebar.removeEventListener('click', handleSidebarNavigation);
                };
            }
        };

        // 🔧 Agregar listener de fallback para el hamburger button en móvil
        const addFallbackHamburgerListener = () => {
            const hamburgerButton = document.querySelector('.navbar-nav .nav-item:first-child .nav-link');
            
            if (hamburgerButton) {
                headerDebug('🔧 Adding fallback hamburger listener');
                
                // Función de fallback que funciona directamente con el DOM
                const fallbackToggle = (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    headerDebug('🔧 Fallback hamburger toggle triggered');
                    
                    const body = document.querySelector('body');
                    if (body) {
                        const isCollapsed = body.classList.contains('sidebar-collapse');
                        const isMobile = window.innerWidth <= 1024; // 🔧 Actualizado para incluir tablets
                        
                        if (isCollapsed) {
                            body.classList.remove('sidebar-collapse');
                            if (isMobile) {
                                setSidebarOpen(true);
                                body.classList.add('sidebar-open-mobile');
                            }
                            headerDebug('🔧 Fallback: Sidebar expanded');
                        } else {
                            body.classList.add('sidebar-collapse');
                            if (isMobile) {
                                setSidebarOpen(false);
                                body.classList.remove('sidebar-open-mobile');
                            }
                            headerDebug('🔧 Fallback: Sidebar collapsed');
                        }
                        
                        // 🔧 Feedback visual con validación null-safe
                        if (hamburgerButton && hamburgerButton.style) {
                            hamburgerButton.style.transform = 'scale(0.9)';
                            hamburgerButton.style.opacity = '0.7';
                            setTimeout(() => {
                                if (hamburgerButton && hamburgerButton.style) {
                                    hamburgerButton.style.transform = '';
                                    hamburgerButton.style.opacity = '';
                                }
                            }, 200);
                        }
                    }
                };
                
                // Agregar múltiples tipos de eventos para máxima compatibilidad
                hamburgerButton.addEventListener('touchstart', fallbackToggle, { passive: false });
                hamburgerButton.addEventListener('touchend', (e) => e.preventDefault(), { passive: false });
                hamburgerButton.addEventListener('click', fallbackToggle);
                
                // Cleanup function para remover listeners
                return () => {
                    hamburgerButton.removeEventListener('touchstart', fallbackToggle);
                    hamburgerButton.removeEventListener('touchend', (e) => e.preventDefault());
                    hamburgerButton.removeEventListener('click', fallbackToggle);
                };
            }
        };
        
        // Agregar listeners después de que el componente se monte
        const timeoutId = setTimeout(() => {
            const cleanup = addFallbackHamburgerListener();
            const sidebarCleanup = addSidebarLinkListeners(); // 🔧 Agregar listeners del sidebar
            
            // Guardar las funciones de cleanup
            if (cleanup) {
                window.hamburgerCleanup = cleanup;
            }
            if (sidebarCleanup) {
                window.sidebarCleanup = sidebarCleanup;
            }
        }, 100);

        document.addEventListener('click', handleClickOutside);
        document.addEventListener('click', handleOverlayClick); // 🔧 Listener para overlay
        document.addEventListener('click', handleSidebarLinkClick); // 🔧 Listener para links del sidebar
        
        return () => {
            document.removeEventListener('click', handleClickOutside);
            document.removeEventListener('click', handleOverlayClick); // 🔧 Cleanup overlay listener
            document.removeEventListener('click', handleSidebarLinkClick); // 🔧 Cleanup sidebar link listener
            clearTimeout(timeoutId);
            
            // Ejecutar cleanup si existe
            if (window.hamburgerCleanup) {
                window.hamburgerCleanup();
                delete window.hamburgerCleanup;
            }
            if (window.sidebarCleanup) {
                window.sidebarCleanup();
                delete window.sidebarCleanup;
            }
        };
    }, [sidebarOpen]); // 🔧 Agregar sidebarOpen como dependencia

    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: selectDebugStyles }} />
            
            {/* 🔧 OVERLAY OSCURO PARA MÓVIL Y TABLET */}
            {sidebarOpen && window.innerWidth <= 1024 && (
                <div 
                    className="mobile-sidebar-overlay"
                    onClick={closeSidebar}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1040,
                        opacity: 1,
                        transition: 'opacity 0.3s ease',
                        pointerEvents: 'auto',
                        cursor: 'pointer'
                    }}
                    aria-label="Cerrar menú"
                />
            )}
            
            <nav className={'main-header navbar navbar-expand navbar-white navbar-light '+headerclass+' '+props.headerCollapsed}>
            
            <ul className="navbar-nav">
                <li className="nav-item" key="header-item-1">
                    <a 
                        className="nav-link" 
                        href="#" 
                        role="button" 
                        onClick={handleSidebarToggleUnified}
                        onTouchStart={handleSidebarToggleUnified}
                        onTouchEnd={(e) => e.preventDefault()}
                        onMouseDown={(e) => e.preventDefault()}
                        style={{
                            cursor: 'pointer',
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            WebkitTouchCallout: 'none',
                            WebkitTapHighlightColor: 'rgba(255,255,255,0.2)',
                            position: 'relative',
                            zIndex: 1000
                        }}
                        aria-label="Toggle sidebar"
                        title="Abrir/Cerrar menú"
                    >
                        <i className="fas fa-bars"></i>
                    </a>
                </li>
            </ul>

            <ul className="navbar-nav ml-auto">
                <li className={`nav-item dropdown ${showUserDropdown ? 'show' : ''}`} key="header-item-3" id="menu-personal">
                    <a 
                        className="nav-link" 
                        href="#" 
                        onClick={handleUserDropdown}
                        onTouchStart={(e) => {
                            e.preventDefault();
                            // 🔧 Feedback visual para touch con validación null-safe
                            if (e.currentTarget && e.currentTarget.style) {
                                e.currentTarget.style.transform = 'scale(0.95)';
                                setTimeout(() => {
                                    if (e.currentTarget && e.currentTarget.style) {
                                        e.currentTarget.style.transform = '';
                                    }
                                }, 150);
                            }
                        }}
                        style={{
                            cursor: 'pointer',
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            WebkitTouchCallout: 'none',
                            WebkitTapHighlightColor: 'rgba(255,255,255,0.2)'
                        }}
                        aria-label="User menu"
                        title="Menú de usuario"
                    >
                        <i className="far fa-user"></i>
                    </a>
                    <div className={`dropdown-menu dropdown-menu-lg dropdown-menu-right ${showUserDropdown ? 'show' : ''}`}>
                        <div className="dropdown-divider"></div>
                        <Link to="/configuracion" className={'dropdown-item'} onClick={() => setShowUserDropdown(false)}>
                            <i className="far fa-address-card mr-2"></i> Opciones personales
                        </Link>
                        <div className="dropdown-divider"></div>
                        <Link to="/cambio-clave" className={'dropdown-item'} onClick={() => setShowUserDropdown(false)}>
                            <i className="fas fa-key mr-2"></i> Cambiar contraseña
                        </Link>
                        <div className="dropdown-divider"></div>
                    </div>
                </li>
                
                <li className={`nav-item dropdown ${showNotificationDropdown ? 'show' : ''}`} key="header-item-4" id="menu-notifications">
                    <a 
                        className="nav-link" 
                        href="#" 
                        onClick={handleNotificationDropdown}
                        onTouchStart={(e) => {
                            e.preventDefault();
                            // 🔧 Feedback visual para touch con validación null-safe
                            if (e.currentTarget && e.currentTarget.style) {
                                e.currentTarget.style.transform = 'scale(0.95)';
                                setTimeout(() => {
                                    if (e.currentTarget && e.currentTarget.style) {
                                        e.currentTarget.style.transform = '';
                                    }
                                }, 150);
                            }
                        }}
                        style={{
                            cursor: 'pointer',
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            WebkitTouchCallout: 'none',
                            WebkitTapHighlightColor: 'rgba(255,255,255,0.2)'
                        }}
                        aria-label="Notifications"
                        title="Notificaciones"
                    >
                        <i className="far fa-bell"></i>
                        {/*<span className="badge badge-warning navbar-badge">15</span>*/}
                    </a>
                    <div className={`dropdown-menu dropdown-menu-lg dropdown-menu-right ${showNotificationDropdown ? 'show' : ''}`}>
                        <span className="dropdown-header">Notificaciones</span>
                        <div className="dropdown-divider"></div>
                        <a href="#" className="dropdown-item" onClick={(e) => e.preventDefault()}>
                            <i className="far fa-comment mr-2"></i> 4 mensajes
                        </a>
                        <div className="dropdown-divider"></div>
                        <a href="#" className="dropdown-item" onClick={(e) => e.preventDefault()}>
                            <i className="far fa-calendar-alt mr-2"></i> 8 recordatorios
                        </a>
                        <div className="dropdown-divider"></div>
                    </div>
                </li>
                <li className="nav-item" key="header-item-5">
                    <Link 
                        to="/logout" 
                        className="nav-link"
                        onTouchStart={(e) => {
                            // 🔧 Feedback visual para touch con validación null-safe
                            if (e.currentTarget && e.currentTarget.style) {
                                e.currentTarget.style.transform = 'scale(0.95)';
                                setTimeout(() => {
                                    if (e.currentTarget && e.currentTarget.style) {
                                        e.currentTarget.style.transform = '';
                                    }
                                }, 150);
                            }
                        }}
                        style={{
                            cursor: 'pointer',
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            WebkitTouchCallout: 'none',
                            WebkitTapHighlightColor: 'rgba(255,255,255,0.2)'
                        }}
                        aria-label="Logout"
                        title="Cerrar sesión"
                    >
                        <i className="fas fa-sign-out-alt"></i>
                    </Link>
                </li>
            
            </ul>
        </nav>
        </>
    );
}

export default Header;